<template>
  <div
    v-if="promotionData"
    :class="[
      $style['promotion'],
    ]"
    :style="{
      'grid-row': `${promotionData.row}`,
      'background-image': backgroundImage ? `url(${backgroundImage})` : null
    }"
    @click="onClick">
    <slot name="backgroundVideo" />
    <div :class="$style['promotion__inner']">
      <div
        v-for="(contentRow, n) in promotionData.content"
        :key="n"
        :class="[$style['promotion__row'], $style['promotion__row--0']]">
        <span>
          {{ contentRow }}
        </span>
      </div>
      <slot />
      <btn
        v-if="promotionData.link && shouldShow(promotionData.link)"
        aria-label="Go to promotion"
        icon-only="System/arrow-right-s-line"
        color="cta"
        shape="round" />
    </div>
  </div>
</template>
<script>
export default {
  props: {
    promotionData: {
      type: [Array, Object, Boolean],
      default: null
    },
    editable: {
      type: Boolean,
      default: false
    },
    backgroundImage: {
      type: String,
      default: null
    }
  },
  computed: {
    styleClass () {
      return this.promotionData
        ? `promotion--${this.promotionData.style}`
        : null
    }
  },
  methods: {
    shouldShow (link) {
      return (
        this.$router.resolve({ path: link }).href !==
        this.$router.resolve({ path: this.$route.fullPath }).href
      )
    },
    onClick () {
      if (this.promotionData.link) {
        this.$router.push(this.promotionData.link).catch(() => {})
      }
    }
  }
}
</script>
<style lang="scss" module>
@use './Shared/style';
</style>
